import { getAccessToken } from '../../../modules/manage-config';

export const getJwtToken = getAccessToken;
